'use client'

import { DropdownItem, DropdownLabel } from '@algoacademy/design-system/web/actions/Dropdown'
import { signOutFromBaza } from '@/app/baza/_components/Navbar/_helpers/sign-out-from-baza'

export function LogoutButton() {
  return (
    <DropdownItem destructive onClick={signOutFromBaza}>
      <DropdownLabel>Wyloguj się</DropdownLabel>
    </DropdownItem>
  )
}
